import { Card } from '@/components/ui/card'
import { cn } from '@/lib/utils'

/* AccentCard — signature-wrapper met een gekleurde border-left.
   Vervangt de wildgroei aan inline `borderLeft: 'Xpx solid #hex'` en
   `borderLeft: 'Xpx solid rgb(var(--tone-rgb))'` varianten. Eén dikte
   (3px), één plek waar we tones definiëren, thema-veilig via CSS-vars.

   Beschikbare tones sluiten aan bij het bestaande palet:
   acid (default) · gold · peach · signal · live · violet · slate · muted */

const TONE_VAR = {
  acid:   'rgb(var(--acid-rgb))',
  gold:   'rgb(var(--gold-rgb))',
  peach:  'rgb(var(--peach-rgb))',
  signal: 'rgb(var(--signal-rgb))',
  live:   'rgb(var(--live-rgb))',
  violet: 'rgb(var(--violet-rgb))',
  slate:  'rgb(var(--slate-rgb))',
  muted:  'hsl(var(--muted-foreground))',
}

export default function AccentCard({ tone = 'acid', className, style, children, ...rest }) {
  const kleur = TONE_VAR[tone] || TONE_VAR.acid
  return (
    <Card
      className={cn('transition-colors', className)}
      style={{ borderLeft: `3px solid ${kleur}`, ...style }}
      {...rest}
    >
      {children}
    </Card>
  )
}
